import React, {useRef} from 'react';
import {Dialog} from '@rneui/themed';
import {Formik} from 'formik';

import {
  GiftCardEntryData,
  GiftCardEntrySchema,
} from '../../../models/schemas/giftCardsSchema';
import TextInput from '../../ui-controls/form/TextInput';
import Text from '../../ui-controls/Text';

const defaultValues: GiftCardEntryData = {
  number: '',
  pin: '',
};

const errorWithFirstLetterCapitalized = (error: any) =>
  error ? error.charAt(0).toUpperCase() + error.slice(1) : undefined;

type ZenGiftCardEntryModalProps = {
  isVisible: boolean;
  onCancel: () => void;
  onAdd: (formValues: GiftCardEntryData) => void;
  isSubmitting: boolean;
  error?: string;
};
export const ZenGiftCardEntryModal = ({
  isVisible,
  isSubmitting,
  onCancel,
  onAdd,
  error,
}: ZenGiftCardEntryModalProps) => {
  const pinInput = useRef<typeof TextInput>(null);

  return (
    <Dialog isVisible={isVisible} onBackdropPress={onCancel}>
      <Dialog.Title title="Add a Gift Card" />
      <Formik<GiftCardEntryData>
        initialValues={defaultValues}
        validationSchema={GiftCardEntrySchema}
        onSubmit={onAdd}>
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          errors,
          touched,
          values,
        }) => (
          <>
            <TextInput
              accessibilityLabel="Card number"
              autoFocus={true}
              errorMessageWhenTouched={errors.number}
              keyboardType="numeric"
              label="Card number"
              onBlur={handleBlur('number')}
              onChangeText={handleChange('number')}
              onSubmitEditing={() => pinInput.current?.focus()}
              placeholder="Enter the card number"
              returnKeyType="next"
              touched={touched.number}
              value={values.number}
            />
            <TextInput
              accessibilityLabel="PIN"
              errorMessageWhenTouched={errors.pin}
              keyboardType="numeric"
              label="PIN"
              onBlur={handleBlur('pin')}
              onChangeText={handleChange('pin')}
              onSubmitEditing={handleSubmit}
              placeholder="Enter the PIN"
              ref={pinInput}
              returnKeyType="done"
              touched={touched.pin}
              value={values.pin}
            />
            {!!error && (
              <Text style={{color: 'red'}}>
                {errorWithFirstLetterCapitalized(error)}
              </Text>
            )}
            <Dialog.Actions>
              <Dialog.Button
                disabled={isSubmitting}
                onPress={onCancel}
                title="CANCEL"
                type="outline"
              />
              <Dialog.Button
                disabled={isSubmitting}
                loading={isSubmitting}
                onPress={handleSubmit}
                title="ADD"
                type="solid"
              />
            </Dialog.Actions>
          </>
        )}
      </Formik>
    </Dialog>
  );
};
